import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { MonDatePickerModule } from '@monsido/angular-shared-components';
import { CommonModule } from '@angular/common';
import { safeClone } from '@client/app/shared/utils/object-utils';

// Wrapper for mon-date-picker component to handling emit dateChange correctly
@Component({
    selector: 'date-picker',
    standalone: true,
    imports: [
        CommonModule,
        MonDatePickerModule,
    ],
    template: `
        <mon-date-picker
                *ngIf="date"
                [unRestrictedMax]="!!unRestrictedMax"
                [monEnableComparisonRange]="monEnableComparisonRange"
                [(date)]="date"
                [monDateFormat]="monDateFormat"
                [monValidateStartDateCb]="monValidateStartDateCb"
                [monValidateEndDateCb]="monValidateEndDateCb"
                (comparisonUpdate)="comparisonUpdate.emit($event)"
                (dateChange)="updateDateRange()"
                [options]="options"
        ></mon-date-picker>
    `,
})
export class DatePickerComponent implements OnInit {
    @Input() date: Record<string, moment.Moment> | null = null;
    @Input() monDateFormat: string = 'YYYY-MM-DD';
    @Input() monValidateStartDateCb: (date: moment.Moment) => string = () => '';
    @Input() monValidateEndDateCb: (date: moment.Moment) => string = () => '';
    @Input() monEnableComparisonRange = false;
    @Input() options: any = {};
    @Input() unRestrictedMax?: boolean = false;

    @Output() comparisonUpdate = new EventEmitter<Record<string, moment.Moment>>();
    @Output() dateChange = new EventEmitter<Record<string, moment.Moment>>();

    lastSelectedDate: Record<string, moment.Moment> | null = null;

    ngOnInit () {
        this.lastSelectedDate = safeClone(this.date);
    }

    updateDateRange (): void {
        if (!this.date) {
            return;
        }

        if (!this.lastSelectedDate) {
            this.lastSelectedDate = safeClone(this.date);
        } else if (
            this.lastSelectedDate.startDate.isSame(this.date.startDate) &&
            this.lastSelectedDate.endDate.isSame(this.date.endDate)
        ) {
            return;
        }

        this.lastSelectedDate = safeClone(this.date);
        this.dateChange.emit(this.date);
    }
}
